<template>
<div>
  <div class="container-base format-detail"
       v-if="format">
    <div class="flex align-items-center">
      <h1>{{ format.title }}</h1>
    </div>
    <div class="card detail">

      <div class="card-thumbnail">
        <ul class="doc-sample-images">
          <li v-for="(img, index) in format.images"
              :key="index"><img :src="img"
                 :alt='`${format.title}テンプレート ${index}`'></li>
        </ul>
      </div>
      <div class="card-data">
        <div class="description">{{ format.description }}</div>
        <el-button class="button-block"
                    v-if="formatId == 'shokumukeirekisho' && $site.appFlag!='b' && false"
                    type="primary"
                     @click="openKeirekisho()"
                    v-ripple>様々な種類の職務経歴書を見る</el-button>
        <br>
        <router-link :to="{ name: 'formatEdit', params: {formatId: format.id}}"
                     v-ripple>
          <el-button class="button-block"
                     type="primary"
                     v-ripple>入力をはじめる</el-button>
        </router-link>
        <div class="text-center">
          <el-button @click="$eventHub.$emit('open-account-dialog')"
                     type="text">
            <span v-if="$yagi.profile.autoSaveEnabled"
                  class="autosave-status on"><i class="el-icon-circle-check"></i> ブラウザに自動保存: オン</span>
            <span v-else
                  class="autosave-status off"><i class="el-icon-circle-close"></i> ブラウザに自動保存: オフ</span>
          </el-button>
        </div>
      </div>

    </div>
  </div>
  <div class="keyword_block">
    <div class="mv">
        <ul class="renew2_flex renew2_sp_flex mv_txtblock">
            <li class="mv__txt">
                <p ><span class="mv__green">会員登録</span><span 
                        class="mv__small">で</span><br >バックアップ<br >機能</p>
            </li>
            <li class="mv__txt">
                <p ><span class="mv__green">無料</span><span 
                        class="mv__small">で</span>履歴書<br >簡単入力</p>
            </li>
        </ul>
    </div>
</div>
</div>
</template>
<style scoped>
    .keyword_block .mv{
        padding: 20px 50px 40px;
        text-align: center;
    }

    .keyword_block .mv .mv_txtblock{
        justify-content: center;
        font-weight: 700;
        margin-bottom: 5px;
    }

    .keyword_block .mv .mv__txt{
        position: relative;
        font-size: 1.2rem;
        text-align: center;
        background: #fff;
        -webkit-box-shadow: 0 0 4px rgba(0,0,0,.25);
        box-shadow: 0 0 4px rgba(0,0,0,.25);
        border-radius: 50%;
        width: 150px;
        height: 150px;
        margin-left: 15px;
    }

    .keyword_block .mv .mv__txt:first-child{
        margin-left: 0;
    }

    .keyword_block .mv .mv__txt p{
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 150px;
        text-align: center;
    }

    .keyword_block .mv .mv__txt .mv__green{
        color: #0f9934;
    }

    .keyword_block .mv .mv__txt .mv__small{
        font-size: 0.8rem;
    }

    @media screen and (max-width: 640px){
        .keyword_block .mv .mv__txt{
            font-size: 1rem;
            width: 130px;
            height: 130px;
        }
        .keyword_block .mv .mv__txt p{
            width: 130px;
        }
    }

</style>
<script>
export default {
  props: {
    formatId: {
      type: String
    },
    univId: {
      type: String
    }
  },
  computed: {
    format: function (id) {
      return this.$site.getFormatById(this.formatId)
    }
  },
  methods: {
    openKeirekisho: function () {
      let link = document.createElement('a')
      link.href = 'https://bit.ly/3tXEmBS'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },
  beforeMount: function () {
    console.error(this.univId)
    if (this.univId) {
      this.$cookies.config(60 * 60 * 24,'')
      this.$cookies.set('_YAGISH_ATHLETE_UNIVID', this.univId, null, null, 'yagish.jp')
      this.$cookies.set('_YAGISH_ATHLETE_UNIVID', this.univId, null, null, 'localhost')
    }
    if (!this.format) {
      this.$router.replace({
        name: 'notFound'
      })
    }
  }
}
</script>
